import { render, staticRenderFns } from "./kfcMenuItem.vue?vue&type=template&id=9c57faca&scoped=true"
import script from "./kfcMenuItem.vue?vue&type=script&lang=js"
export * from "./kfcMenuItem.vue?vue&type=script&lang=js"
import style0 from "./kfcMenuItem.vue?vue&type=style&index=0&id=9c57faca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c57faca",
  null
  
)

export default component.exports